// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               v7.35.1
// source: cairn/v1/sync.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "cairn.v1";

export enum Mode {
  MODE_UNSPECIFIED = 0,
  MODE_LIVE = 1,
  MODE_BACKGROUND = 2,
  UNRECOGNIZED = -1,
}

export function modeFromJSON(object: any): Mode {
  switch (object) {
    case 0:
    case "MODE_UNSPECIFIED":
      return Mode.MODE_UNSPECIFIED;
    case 1:
    case "MODE_LIVE":
      return Mode.MODE_LIVE;
    case 2:
    case "MODE_BACKGROUND":
      return Mode.MODE_BACKGROUND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Mode.UNRECOGNIZED;
  }
}

export function modeToJSON(object: Mode): string {
  switch (object) {
    case Mode.MODE_UNSPECIFIED:
      return "MODE_UNSPECIFIED";
    case Mode.MODE_LIVE:
      return "MODE_LIVE";
    case Mode.MODE_BACKGROUND:
      return "MODE_BACKGROUND";
    case Mode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Role {
  ROLE_UNSPECIFIED = 0,
  ROLE_VIEWER = 1,
  ROLE_EDITOR = 2,
  ROLE_OWNER = 3,
  UNRECOGNIZED = -1,
}

export function roleFromJSON(object: any): Role {
  switch (object) {
    case 0:
    case "ROLE_UNSPECIFIED":
      return Role.ROLE_UNSPECIFIED;
    case 1:
    case "ROLE_VIEWER":
      return Role.ROLE_VIEWER;
    case 2:
    case "ROLE_EDITOR":
      return Role.ROLE_EDITOR;
    case 3:
    case "ROLE_OWNER":
      return Role.ROLE_OWNER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Role.UNRECOGNIZED;
  }
}

export function roleToJSON(object: Role): string {
  switch (object) {
    case Role.ROLE_UNSPECIFIED:
      return "ROLE_UNSPECIFIED";
    case Role.ROLE_VIEWER:
      return "ROLE_VIEWER";
    case Role.ROLE_EDITOR:
      return "ROLE_EDITOR";
    case Role.ROLE_OWNER:
      return "ROLE_OWNER";
    case Role.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Reason {
  REASON_UNSPECIFIED = 0,
  /** READ_ONLY - viewer sent a doc update */
  READ_ONLY = 1,
  /** TOO_LARGE - message or resulting doc exceeds caps */
  TOO_LARGE = 2,
  /** INVALID - malformed payload or meta-doc schema violation */
  INVALID = 3,
  RATE_LIMITED = 4,
  /** NOT_FOUND - unknown doc_id for this vault */
  NOT_FOUND = 5,
  /** EPOCH_STALE - update targeted an epoch the server no longer serves */
  EPOCH_STALE = 6,
  UNRECOGNIZED = -1,
}

export function reasonFromJSON(object: any): Reason {
  switch (object) {
    case 0:
    case "REASON_UNSPECIFIED":
      return Reason.REASON_UNSPECIFIED;
    case 1:
    case "READ_ONLY":
      return Reason.READ_ONLY;
    case 2:
    case "TOO_LARGE":
      return Reason.TOO_LARGE;
    case 3:
    case "INVALID":
      return Reason.INVALID;
    case 4:
    case "RATE_LIMITED":
      return Reason.RATE_LIMITED;
    case 5:
    case "NOT_FOUND":
      return Reason.NOT_FOUND;
    case 6:
    case "EPOCH_STALE":
      return Reason.EPOCH_STALE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Reason.UNRECOGNIZED;
  }
}

export function reasonToJSON(object: Reason): string {
  switch (object) {
    case Reason.REASON_UNSPECIFIED:
      return "REASON_UNSPECIFIED";
    case Reason.READ_ONLY:
      return "READ_ONLY";
    case Reason.TOO_LARGE:
      return "TOO_LARGE";
    case Reason.INVALID:
      return "INVALID";
    case Reason.RATE_LIMITED:
      return "RATE_LIMITED";
    case Reason.NOT_FOUND:
      return "NOT_FOUND";
    case Reason.EPOCH_STALE:
      return "EPOCH_STALE";
    case Reason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CloseReason {
  CLOSE_UNSPECIFIED = 0,
  AUTH_FAILED = 1,
  AUTH_TIMEOUT = 2,
  /** TOKEN_EXPIRED - client should mint a new sync token and reconnect */
  TOKEN_EXPIRED = 3,
  /** KICKED - membership revoked */
  KICKED = 4,
  /** OVERLOADED - backpressure last resort; client backs off */
  OVERLOADED = 5,
  /** PROTOCOL - repeated violations */
  PROTOCOL = 6,
  /** SHUTTING_DOWN - deploy drain; reconnect with backoff */
  SHUTTING_DOWN = 7,
  UNRECOGNIZED = -1,
}

export function closeReasonFromJSON(object: any): CloseReason {
  switch (object) {
    case 0:
    case "CLOSE_UNSPECIFIED":
      return CloseReason.CLOSE_UNSPECIFIED;
    case 1:
    case "AUTH_FAILED":
      return CloseReason.AUTH_FAILED;
    case 2:
    case "AUTH_TIMEOUT":
      return CloseReason.AUTH_TIMEOUT;
    case 3:
    case "TOKEN_EXPIRED":
      return CloseReason.TOKEN_EXPIRED;
    case 4:
    case "KICKED":
      return CloseReason.KICKED;
    case 5:
    case "OVERLOADED":
      return CloseReason.OVERLOADED;
    case 6:
    case "PROTOCOL":
      return CloseReason.PROTOCOL;
    case 7:
    case "SHUTTING_DOWN":
      return CloseReason.SHUTTING_DOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CloseReason.UNRECOGNIZED;
  }
}

export function closeReasonToJSON(object: CloseReason): string {
  switch (object) {
    case CloseReason.CLOSE_UNSPECIFIED:
      return "CLOSE_UNSPECIFIED";
    case CloseReason.AUTH_FAILED:
      return "AUTH_FAILED";
    case CloseReason.AUTH_TIMEOUT:
      return "AUTH_TIMEOUT";
    case CloseReason.TOKEN_EXPIRED:
      return "TOKEN_EXPIRED";
    case CloseReason.KICKED:
      return "KICKED";
    case CloseReason.OVERLOADED:
      return "OVERLOADED";
    case CloseReason.PROTOCOL:
      return "PROTOCOL";
    case CloseReason.SHUTTING_DOWN:
      return "SHUTTING_DOWN";
    case CloseReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ClientMessage {
  auth?: Auth | undefined;
  subscribe?: SubscribeBatch | undefined;
  unsubscribe?: UnsubscribeBatch | undefined;
  setMode?: SetMode | undefined;
  doc?: DocPayload | undefined;
  ping?: Ping | undefined;
}

export interface Auth {
  syncToken: string;
}

export interface Subscription {
  /** ULID; "meta" is reserved for the meta doc */
  docId: string;
  mode: Mode;
  /** 0 if none */
  knownEpoch: number;
  /** Yjs SV; empty = full sync */
  stateVector: Uint8Array;
}

export interface SubscribeBatch {
  subs: Subscription[];
}

export interface UnsubscribeBatch {
  docIds: string[];
}

export interface SetMode {
  docId: string;
  mode: Mode;
}

export interface DocPayload {
  docId: string;
  /** y-protocols frame(s): sync step1/step2/update, or awareness */
  payload: Uint8Array;
}

export interface Ping {
  nonce: number;
}

export interface ServerMessage {
  authAck?: AuthAck | undefined;
  subscribeAck?: SubscribeAck | undefined;
  doc?: DocPayload | undefined;
  rejected?: Rejected | undefined;
  event?: VaultEvent | undefined;
  pong?: Pong | undefined;
  close?: Close | undefined;
}

export interface AuthAck {
  userId: string;
  role: Role;
}

export interface SubscribeAck {
  docId: string;
  epoch: number;
  /** true -> client MUST drop local Yjs state for this doc and full-resync */
  epochChanged: boolean;
}

export interface Rejected {
  /** empty when connection-scoped (e.g. RATE_LIMITED) */
  docId: string;
  reason: Reason;
  detail: string;
}

export interface VaultEvent {
  /** another client created a file */
  docCreated?:
    | DocCreated
    | undefined;
  /** GC or delete finalized */
  docRemoved?:
    | DocRemoved
    | undefined;
  /** server refreshed this connection's role */
  roleChanged?: RoleChanged | undefined;
}

export interface DocCreated {
  docId: string;
}

export interface DocRemoved {
  docId: string;
}

export interface RoleChanged {
  role: Role;
}

export interface Pong {
  nonce: number;
}

export interface Close {
  reason: CloseReason;
  detail: string;
}

function createBaseClientMessage(): ClientMessage {
  return {
    auth: undefined,
    subscribe: undefined,
    unsubscribe: undefined,
    setMode: undefined,
    doc: undefined,
    ping: undefined,
  };
}

export const ClientMessage: MessageFns<ClientMessage> = {
  encode(message: ClientMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.auth !== undefined) {
      Auth.encode(message.auth, writer.uint32(10).fork()).join();
    }
    if (message.subscribe !== undefined) {
      SubscribeBatch.encode(message.subscribe, writer.uint32(18).fork()).join();
    }
    if (message.unsubscribe !== undefined) {
      UnsubscribeBatch.encode(message.unsubscribe, writer.uint32(26).fork()).join();
    }
    if (message.setMode !== undefined) {
      SetMode.encode(message.setMode, writer.uint32(34).fork()).join();
    }
    if (message.doc !== undefined) {
      DocPayload.encode(message.doc, writer.uint32(42).fork()).join();
    }
    if (message.ping !== undefined) {
      Ping.encode(message.ping, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClientMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.auth = Auth.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subscribe = SubscribeBatch.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.unsubscribe = UnsubscribeBatch.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setMode = SetMode.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.doc = DocPayload.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ping = Ping.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClientMessage {
    return {
      auth: isSet(object.auth) ? Auth.fromJSON(object.auth) : undefined,
      subscribe: isSet(object.subscribe) ? SubscribeBatch.fromJSON(object.subscribe) : undefined,
      unsubscribe: isSet(object.unsubscribe) ? UnsubscribeBatch.fromJSON(object.unsubscribe) : undefined,
      setMode: isSet(object.setMode)
        ? SetMode.fromJSON(object.setMode)
        : isSet(object.set_mode)
        ? SetMode.fromJSON(object.set_mode)
        : undefined,
      doc: isSet(object.doc) ? DocPayload.fromJSON(object.doc) : undefined,
      ping: isSet(object.ping) ? Ping.fromJSON(object.ping) : undefined,
    };
  },

  toJSON(message: ClientMessage): unknown {
    const obj: any = {};
    if (message.auth !== undefined) {
      obj.auth = Auth.toJSON(message.auth);
    }
    if (message.subscribe !== undefined) {
      obj.subscribe = SubscribeBatch.toJSON(message.subscribe);
    }
    if (message.unsubscribe !== undefined) {
      obj.unsubscribe = UnsubscribeBatch.toJSON(message.unsubscribe);
    }
    if (message.setMode !== undefined) {
      obj.setMode = SetMode.toJSON(message.setMode);
    }
    if (message.doc !== undefined) {
      obj.doc = DocPayload.toJSON(message.doc);
    }
    if (message.ping !== undefined) {
      obj.ping = Ping.toJSON(message.ping);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientMessage>, I>>(base?: I): ClientMessage {
    return ClientMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientMessage>, I>>(object: I): ClientMessage {
    const message = createBaseClientMessage();
    message.auth = (object.auth !== undefined && object.auth !== null) ? Auth.fromPartial(object.auth) : undefined;
    message.subscribe = (object.subscribe !== undefined && object.subscribe !== null)
      ? SubscribeBatch.fromPartial(object.subscribe)
      : undefined;
    message.unsubscribe = (object.unsubscribe !== undefined && object.unsubscribe !== null)
      ? UnsubscribeBatch.fromPartial(object.unsubscribe)
      : undefined;
    message.setMode = (object.setMode !== undefined && object.setMode !== null)
      ? SetMode.fromPartial(object.setMode)
      : undefined;
    message.doc = (object.doc !== undefined && object.doc !== null) ? DocPayload.fromPartial(object.doc) : undefined;
    message.ping = (object.ping !== undefined && object.ping !== null) ? Ping.fromPartial(object.ping) : undefined;
    return message;
  },
};

function createBaseAuth(): Auth {
  return { syncToken: "" };
}

export const Auth: MessageFns<Auth> = {
  encode(message: Auth, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncToken !== "") {
      writer.uint32(10).string(message.syncToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Auth {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuth();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Auth {
    return {
      syncToken: isSet(object.syncToken)
        ? globalThis.String(object.syncToken)
        : isSet(object.sync_token)
        ? globalThis.String(object.sync_token)
        : "",
    };
  },

  toJSON(message: Auth): unknown {
    const obj: any = {};
    if (message.syncToken !== "") {
      obj.syncToken = message.syncToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Auth>, I>>(base?: I): Auth {
    return Auth.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Auth>, I>>(object: I): Auth {
    const message = createBaseAuth();
    message.syncToken = object.syncToken ?? "";
    return message;
  },
};

function createBaseSubscription(): Subscription {
  return { docId: "", mode: 0, knownEpoch: 0, stateVector: new Uint8Array(0) };
}

export const Subscription: MessageFns<Subscription> = {
  encode(message: Subscription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.knownEpoch !== 0) {
      writer.uint32(24).uint32(message.knownEpoch);
    }
    if (message.stateVector.length !== 0) {
      writer.uint32(34).bytes(message.stateVector);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Subscription {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.knownEpoch = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stateVector = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Subscription {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
      mode: isSet(object.mode) ? modeFromJSON(object.mode) : 0,
      knownEpoch: isSet(object.knownEpoch)
        ? globalThis.Number(object.knownEpoch)
        : isSet(object.known_epoch)
        ? globalThis.Number(object.known_epoch)
        : 0,
      stateVector: isSet(object.stateVector)
        ? bytesFromBase64(object.stateVector)
        : isSet(object.state_vector)
        ? bytesFromBase64(object.state_vector)
        : new Uint8Array(0),
    };
  },

  toJSON(message: Subscription): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    if (message.mode !== 0) {
      obj.mode = modeToJSON(message.mode);
    }
    if (message.knownEpoch !== 0) {
      obj.knownEpoch = Math.round(message.knownEpoch);
    }
    if (message.stateVector.length !== 0) {
      obj.stateVector = base64FromBytes(message.stateVector);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Subscription>, I>>(base?: I): Subscription {
    return Subscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Subscription>, I>>(object: I): Subscription {
    const message = createBaseSubscription();
    message.docId = object.docId ?? "";
    message.mode = object.mode ?? 0;
    message.knownEpoch = object.knownEpoch ?? 0;
    message.stateVector = object.stateVector ?? new Uint8Array(0);
    return message;
  },
};

function createBaseSubscribeBatch(): SubscribeBatch {
  return { subs: [] };
}

export const SubscribeBatch: MessageFns<SubscribeBatch> = {
  encode(message: SubscribeBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.subs) {
      Subscription.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.subs.push(Subscription.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeBatch {
    return {
      subs: globalThis.Array.isArray(object?.subs) ? object.subs.map((e: any) => Subscription.fromJSON(e)) : [],
    };
  },

  toJSON(message: SubscribeBatch): unknown {
    const obj: any = {};
    if (message.subs?.length) {
      obj.subs = message.subs.map((e) => Subscription.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscribeBatch>, I>>(base?: I): SubscribeBatch {
    return SubscribeBatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscribeBatch>, I>>(object: I): SubscribeBatch {
    const message = createBaseSubscribeBatch();
    message.subs = object.subs?.map((e) => Subscription.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUnsubscribeBatch(): UnsubscribeBatch {
  return { docIds: [] };
}

export const UnsubscribeBatch: MessageFns<UnsubscribeBatch> = {
  encode(message: UnsubscribeBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.docIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnsubscribeBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnsubscribeBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnsubscribeBatch {
    return {
      docIds: globalThis.Array.isArray(object?.docIds)
        ? object.docIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.doc_ids)
        ? object.doc_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UnsubscribeBatch): unknown {
    const obj: any = {};
    if (message.docIds?.length) {
      obj.docIds = message.docIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnsubscribeBatch>, I>>(base?: I): UnsubscribeBatch {
    return UnsubscribeBatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnsubscribeBatch>, I>>(object: I): UnsubscribeBatch {
    const message = createBaseUnsubscribeBatch();
    message.docIds = object.docIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseSetMode(): SetMode {
  return { docId: "", mode: 0 };
}

export const SetMode: MessageFns<SetMode> = {
  encode(message: SetMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMode {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
      mode: isSet(object.mode) ? modeFromJSON(object.mode) : 0,
    };
  },

  toJSON(message: SetMode): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    if (message.mode !== 0) {
      obj.mode = modeToJSON(message.mode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMode>, I>>(base?: I): SetMode {
    return SetMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMode>, I>>(object: I): SetMode {
    const message = createBaseSetMode();
    message.docId = object.docId ?? "";
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseDocPayload(): DocPayload {
  return { docId: "", payload: new Uint8Array(0) };
}

export const DocPayload: MessageFns<DocPayload> = {
  encode(message: DocPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payload = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocPayload {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
      payload: isSet(object.payload) ? bytesFromBase64(object.payload) : new Uint8Array(0),
    };
  },

  toJSON(message: DocPayload): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes(message.payload);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DocPayload>, I>>(base?: I): DocPayload {
    return DocPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DocPayload>, I>>(object: I): DocPayload {
    const message = createBaseDocPayload();
    message.docId = object.docId ?? "";
    message.payload = object.payload ?? new Uint8Array(0);
    return message;
  },
};

function createBasePing(): Ping {
  return { nonce: 0 };
}

export const Ping: MessageFns<Ping> = {
  encode(message: Ping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nonce !== 0) {
      writer.uint32(8).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Ping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nonce = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Ping {
    return { nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0 };
  },

  toJSON(message: Ping): unknown {
    const obj: any = {};
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Ping>, I>>(base?: I): Ping {
    return Ping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Ping>, I>>(object: I): Ping {
    const message = createBasePing();
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseServerMessage(): ServerMessage {
  return {
    authAck: undefined,
    subscribeAck: undefined,
    doc: undefined,
    rejected: undefined,
    event: undefined,
    pong: undefined,
    close: undefined,
  };
}

export const ServerMessage: MessageFns<ServerMessage> = {
  encode(message: ServerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.authAck !== undefined) {
      AuthAck.encode(message.authAck, writer.uint32(10).fork()).join();
    }
    if (message.subscribeAck !== undefined) {
      SubscribeAck.encode(message.subscribeAck, writer.uint32(18).fork()).join();
    }
    if (message.doc !== undefined) {
      DocPayload.encode(message.doc, writer.uint32(26).fork()).join();
    }
    if (message.rejected !== undefined) {
      Rejected.encode(message.rejected, writer.uint32(34).fork()).join();
    }
    if (message.event !== undefined) {
      VaultEvent.encode(message.event, writer.uint32(42).fork()).join();
    }
    if (message.pong !== undefined) {
      Pong.encode(message.pong, writer.uint32(50).fork()).join();
    }
    if (message.close !== undefined) {
      Close.encode(message.close, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.authAck = AuthAck.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subscribeAck = SubscribeAck.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.doc = DocPayload.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.rejected = Rejected.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.event = VaultEvent.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pong = Pong.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.close = Close.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerMessage {
    return {
      authAck: isSet(object.authAck)
        ? AuthAck.fromJSON(object.authAck)
        : isSet(object.auth_ack)
        ? AuthAck.fromJSON(object.auth_ack)
        : undefined,
      subscribeAck: isSet(object.subscribeAck)
        ? SubscribeAck.fromJSON(object.subscribeAck)
        : isSet(object.subscribe_ack)
        ? SubscribeAck.fromJSON(object.subscribe_ack)
        : undefined,
      doc: isSet(object.doc) ? DocPayload.fromJSON(object.doc) : undefined,
      rejected: isSet(object.rejected) ? Rejected.fromJSON(object.rejected) : undefined,
      event: isSet(object.event) ? VaultEvent.fromJSON(object.event) : undefined,
      pong: isSet(object.pong) ? Pong.fromJSON(object.pong) : undefined,
      close: isSet(object.close) ? Close.fromJSON(object.close) : undefined,
    };
  },

  toJSON(message: ServerMessage): unknown {
    const obj: any = {};
    if (message.authAck !== undefined) {
      obj.authAck = AuthAck.toJSON(message.authAck);
    }
    if (message.subscribeAck !== undefined) {
      obj.subscribeAck = SubscribeAck.toJSON(message.subscribeAck);
    }
    if (message.doc !== undefined) {
      obj.doc = DocPayload.toJSON(message.doc);
    }
    if (message.rejected !== undefined) {
      obj.rejected = Rejected.toJSON(message.rejected);
    }
    if (message.event !== undefined) {
      obj.event = VaultEvent.toJSON(message.event);
    }
    if (message.pong !== undefined) {
      obj.pong = Pong.toJSON(message.pong);
    }
    if (message.close !== undefined) {
      obj.close = Close.toJSON(message.close);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerMessage>, I>>(base?: I): ServerMessage {
    return ServerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerMessage>, I>>(object: I): ServerMessage {
    const message = createBaseServerMessage();
    message.authAck = (object.authAck !== undefined && object.authAck !== null)
      ? AuthAck.fromPartial(object.authAck)
      : undefined;
    message.subscribeAck = (object.subscribeAck !== undefined && object.subscribeAck !== null)
      ? SubscribeAck.fromPartial(object.subscribeAck)
      : undefined;
    message.doc = (object.doc !== undefined && object.doc !== null) ? DocPayload.fromPartial(object.doc) : undefined;
    message.rejected = (object.rejected !== undefined && object.rejected !== null)
      ? Rejected.fromPartial(object.rejected)
      : undefined;
    message.event = (object.event !== undefined && object.event !== null)
      ? VaultEvent.fromPartial(object.event)
      : undefined;
    message.pong = (object.pong !== undefined && object.pong !== null) ? Pong.fromPartial(object.pong) : undefined;
    message.close = (object.close !== undefined && object.close !== null) ? Close.fromPartial(object.close) : undefined;
    return message;
  },
};

function createBaseAuthAck(): AuthAck {
  return { userId: "", role: 0 };
}

export const AuthAck: MessageFns<AuthAck> = {
  encode(message: AuthAck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.role !== 0) {
      writer.uint32(16).int32(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AuthAck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthAck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AuthAck {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      role: isSet(object.role) ? roleFromJSON(object.role) : 0,
    };
  },

  toJSON(message: AuthAck): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.role !== 0) {
      obj.role = roleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthAck>, I>>(base?: I): AuthAck {
    return AuthAck.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AuthAck>, I>>(object: I): AuthAck {
    const message = createBaseAuthAck();
    message.userId = object.userId ?? "";
    message.role = object.role ?? 0;
    return message;
  },
};

function createBaseSubscribeAck(): SubscribeAck {
  return { docId: "", epoch: 0, epochChanged: false };
}

export const SubscribeAck: MessageFns<SubscribeAck> = {
  encode(message: SubscribeAck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    if (message.epoch !== 0) {
      writer.uint32(16).uint32(message.epoch);
    }
    if (message.epochChanged !== false) {
      writer.uint32(24).bool(message.epochChanged);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeAck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeAck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.epoch = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.epochChanged = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeAck {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
      epoch: isSet(object.epoch) ? globalThis.Number(object.epoch) : 0,
      epochChanged: isSet(object.epochChanged)
        ? globalThis.Boolean(object.epochChanged)
        : isSet(object.epoch_changed)
        ? globalThis.Boolean(object.epoch_changed)
        : false,
    };
  },

  toJSON(message: SubscribeAck): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    if (message.epoch !== 0) {
      obj.epoch = Math.round(message.epoch);
    }
    if (message.epochChanged !== false) {
      obj.epochChanged = message.epochChanged;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscribeAck>, I>>(base?: I): SubscribeAck {
    return SubscribeAck.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscribeAck>, I>>(object: I): SubscribeAck {
    const message = createBaseSubscribeAck();
    message.docId = object.docId ?? "";
    message.epoch = object.epoch ?? 0;
    message.epochChanged = object.epochChanged ?? false;
    return message;
  },
};

function createBaseRejected(): Rejected {
  return { docId: "", reason: 0, detail: "" };
}

export const Rejected: MessageFns<Rejected> = {
  encode(message: Rejected, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    if (message.reason !== 0) {
      writer.uint32(16).int32(message.reason);
    }
    if (message.detail !== "") {
      writer.uint32(26).string(message.detail);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Rejected {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRejected();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Rejected {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
      reason: isSet(object.reason) ? reasonFromJSON(object.reason) : 0,
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
    };
  },

  toJSON(message: Rejected): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    if (message.reason !== 0) {
      obj.reason = reasonToJSON(message.reason);
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Rejected>, I>>(base?: I): Rejected {
    return Rejected.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Rejected>, I>>(object: I): Rejected {
    const message = createBaseRejected();
    message.docId = object.docId ?? "";
    message.reason = object.reason ?? 0;
    message.detail = object.detail ?? "";
    return message;
  },
};

function createBaseVaultEvent(): VaultEvent {
  return { docCreated: undefined, docRemoved: undefined, roleChanged: undefined };
}

export const VaultEvent: MessageFns<VaultEvent> = {
  encode(message: VaultEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docCreated !== undefined) {
      DocCreated.encode(message.docCreated, writer.uint32(10).fork()).join();
    }
    if (message.docRemoved !== undefined) {
      DocRemoved.encode(message.docRemoved, writer.uint32(18).fork()).join();
    }
    if (message.roleChanged !== undefined) {
      RoleChanged.encode(message.roleChanged, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VaultEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVaultEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docCreated = DocCreated.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.docRemoved = DocRemoved.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.roleChanged = RoleChanged.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VaultEvent {
    return {
      docCreated: isSet(object.docCreated)
        ? DocCreated.fromJSON(object.docCreated)
        : isSet(object.doc_created)
        ? DocCreated.fromJSON(object.doc_created)
        : undefined,
      docRemoved: isSet(object.docRemoved)
        ? DocRemoved.fromJSON(object.docRemoved)
        : isSet(object.doc_removed)
        ? DocRemoved.fromJSON(object.doc_removed)
        : undefined,
      roleChanged: isSet(object.roleChanged)
        ? RoleChanged.fromJSON(object.roleChanged)
        : isSet(object.role_changed)
        ? RoleChanged.fromJSON(object.role_changed)
        : undefined,
    };
  },

  toJSON(message: VaultEvent): unknown {
    const obj: any = {};
    if (message.docCreated !== undefined) {
      obj.docCreated = DocCreated.toJSON(message.docCreated);
    }
    if (message.docRemoved !== undefined) {
      obj.docRemoved = DocRemoved.toJSON(message.docRemoved);
    }
    if (message.roleChanged !== undefined) {
      obj.roleChanged = RoleChanged.toJSON(message.roleChanged);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VaultEvent>, I>>(base?: I): VaultEvent {
    return VaultEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VaultEvent>, I>>(object: I): VaultEvent {
    const message = createBaseVaultEvent();
    message.docCreated = (object.docCreated !== undefined && object.docCreated !== null)
      ? DocCreated.fromPartial(object.docCreated)
      : undefined;
    message.docRemoved = (object.docRemoved !== undefined && object.docRemoved !== null)
      ? DocRemoved.fromPartial(object.docRemoved)
      : undefined;
    message.roleChanged = (object.roleChanged !== undefined && object.roleChanged !== null)
      ? RoleChanged.fromPartial(object.roleChanged)
      : undefined;
    return message;
  },
};

function createBaseDocCreated(): DocCreated {
  return { docId: "" };
}

export const DocCreated: MessageFns<DocCreated> = {
  encode(message: DocCreated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocCreated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocCreated();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocCreated {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
    };
  },

  toJSON(message: DocCreated): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DocCreated>, I>>(base?: I): DocCreated {
    return DocCreated.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DocCreated>, I>>(object: I): DocCreated {
    const message = createBaseDocCreated();
    message.docId = object.docId ?? "";
    return message;
  },
};

function createBaseDocRemoved(): DocRemoved {
  return { docId: "" };
}

export const DocRemoved: MessageFns<DocRemoved> = {
  encode(message: DocRemoved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.docId !== "") {
      writer.uint32(10).string(message.docId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocRemoved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocRemoved();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.docId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocRemoved {
    return {
      docId: isSet(object.docId)
        ? globalThis.String(object.docId)
        : isSet(object.doc_id)
        ? globalThis.String(object.doc_id)
        : "",
    };
  },

  toJSON(message: DocRemoved): unknown {
    const obj: any = {};
    if (message.docId !== "") {
      obj.docId = message.docId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DocRemoved>, I>>(base?: I): DocRemoved {
    return DocRemoved.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DocRemoved>, I>>(object: I): DocRemoved {
    const message = createBaseDocRemoved();
    message.docId = object.docId ?? "";
    return message;
  },
};

function createBaseRoleChanged(): RoleChanged {
  return { role: 0 };
}

export const RoleChanged: MessageFns<RoleChanged> = {
  encode(message: RoleChanged, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.role !== 0) {
      writer.uint32(8).int32(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoleChanged {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoleChanged();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoleChanged {
    return { role: isSet(object.role) ? roleFromJSON(object.role) : 0 };
  },

  toJSON(message: RoleChanged): unknown {
    const obj: any = {};
    if (message.role !== 0) {
      obj.role = roleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoleChanged>, I>>(base?: I): RoleChanged {
    return RoleChanged.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoleChanged>, I>>(object: I): RoleChanged {
    const message = createBaseRoleChanged();
    message.role = object.role ?? 0;
    return message;
  },
};

function createBasePong(): Pong {
  return { nonce: 0 };
}

export const Pong: MessageFns<Pong> = {
  encode(message: Pong, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nonce !== 0) {
      writer.uint32(8).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pong {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePong();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nonce = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pong {
    return { nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0 };
  },

  toJSON(message: Pong): unknown {
    const obj: any = {};
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Pong>, I>>(base?: I): Pong {
    return Pong.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pong>, I>>(object: I): Pong {
    const message = createBasePong();
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseClose(): Close {
  return { reason: 0, detail: "" };
}

export const Close: MessageFns<Close> = {
  encode(message: Close, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reason !== 0) {
      writer.uint32(8).int32(message.reason);
    }
    if (message.detail !== "") {
      writer.uint32(18).string(message.detail);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Close {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClose();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Close {
    return {
      reason: isSet(object.reason) ? closeReasonFromJSON(object.reason) : 0,
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
    };
  },

  toJSON(message: Close): unknown {
    const obj: any = {};
    if (message.reason !== 0) {
      obj.reason = closeReasonToJSON(message.reason);
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Close>, I>>(base?: I): Close {
    return Close.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Close>, I>>(object: I): Close {
    const message = createBaseClose();
    message.reason = object.reason ?? 0;
    message.detail = object.detail ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
